//@flow
import React, { Component } from 'react';
import type { Node } from 'react';
import injectSheet from 'react-jss';
import modalCss from '../styles/modal';
import limitAlert from '../images/reputation.svg';
import closeBtn from '../images/close.svg';
import Button from './button';
import SVGInline from 'react-svg-inline';

/**
* This file is responsible for displaying a reusable modal
* @author Arvind
*/
type State = {
    openModal: boolean
}
type Props = {
    classes: Object,
    shown: boolean,
    handleModalState: Function
}
class AcknowledgeModal extends Component<Props, State> {

    closeModal(state) {
        this.props.handleModalState();
        this.setState({openModal: false});
    }

    render() {
        const { shown } = this.props;
        if(!shown) {
            return null;
        }
        const { classes } = this.props;
        let containerClass = classes.modalCont;
        return (
            <div className={classes.modal}>
                <div className={containerClass} id="limit_exceeded">
                <div id="close-btn-wrapper" onClick={() => this.closeModal(true)}><SVGInline svg={closeBtn} id="close-btn" /></div>
                <SVGInline svg={limitAlert} className={`${classes.icon} h-mr-13p`} id="limit-alert"/>
                    { 
                        <React.Fragment>
                            <div className={classes.modalContent} id="popup-text">
                            Your account deletion request has been cancelled. No changes have been made to your account and you can continue using Hiver as before.
                            </div>
                            <div className={classes.modalAction}>
                                <Button
                                    buttonText="Got it"
                                    clickHandler={() => this.closeModal(true)}
                                />
                            </div>
                        </React.Fragment>          
                    }
                </div>
            </div>
        );
    }
}

export default injectSheet(modalCss)(AcknowledgeModal);    